import $ from 'jquery';
import {
  DataTableComponent,
  batchCheckControls,
} from 'web/components/CommonComponent';
import {useEffect, useRef, useState} from 'react';
import enumList from 'web/utils/enumList';
import {fetchMachineList} from 'web/redux/actions/MachineActions';
import generateRandomID from 'web/utils/generateRandomID';
const {flgStatus: flgStatusEnum} = enumList;

export const useMachine = (
  dispatch,
  showMessage,
  baseComponent,
  checkedMachineIds,
  setCheckedMachineIds,
) => {
  const [machineList, setMachineList] = useState([]);
  const [searchParams, setSearchParams] = useState({
    deliveryCode: '',
    machineSerialNumber: '',
    machineTypeId: '',
  });
  const orderParams = useRef({
    dir: 'asc',
    orderBy: '',
  });
  const tableRef = useRef(null);

  // datatable 屬於單例。條件搜索時，需要重新設定 ajax 來獲取新 query
  useEffect(() => {
    if (!tableRef.current) return;
    if (Object.values(searchParams).some((v) => v)) {
      const table = tableRef.current;
      table.settings()[0].ajax = ajax;
      table.ajax.reload();
    }
  }, [searchParams]);

  useEffect(() => {
    prepareMachineTable();
  }, []);

  const ajax = (data, callback, settings) => {
    const sortParams = settings.sortDetails;
    if (sortParams?.length) {
      orderParams.current.dir = sortParams[0].dir;
      orderParams.current.orderBy = columnConfig[sortParams[0].col].orderName;
    } else {
      orderParams.current = {
        dir: 'asc',
        orderBy: '',
      };
    }

    const start = data.start || 0;
    const length = data.length || PAGE_LENGTH;
    const draw = data.draw || 1;
    // 呼叫 callback，傳入回調函式讓 useMachine 去發 API
    serverPaginationCallback(start, length, callback, draw);
  };

  // 使用者翻頁時觸發
  const serverPaginationCallback = (start, length, dtCallback, draw) => {
    // 計算目前頁數
    const page = Math.floor(start / length) + 1;
    console.log('🟡 serverPaginationCallback called:', {
      start,
      length,
      page,
      draw,
    });
    // 發送 API 請求
    const req = {
      ...searchParams,
      ...orderParams.current,
      limit: length,
      page: page,
    };

    dispatch(fetchMachineList(req))
      .then((res) => {
        console.log('🟢 API 返回:');
        const statusCode = res.payload.code;
        if (statusCode && statusCode.isSuccessCode()) {
          const machineListRes = res.payload.result.data;
          const totalRecords = res.payload.result.total || 0;
          setMachineList(machineListRes);

          // 呼叫 DataTable 的 callback，傳入資料和總筆數
          // 注意：data 需要是物件陣列，對應 DataTable 的欄位定義
          const formattedData = machineListRes.map((machineItem) => ({
            recordYear: machineItem.recordYear,
            deliveryCode: machineItem.deliveryCode,
            machineModel: machineItem.machineModel,
            machineSerialNumber: machineItem.machineSerialNumber,
            imCode: machineItem.imCode,
            machineTypeName: machineItem.machineTypeName,
            statusData: {
              id: machineItem.machineId,
              flgStatus: machineItem.flgStatus,
            },
            memo: machineItem.memo,
          }));

          console.log('🔵 calling dtCallback ');

          dtCallback({
            draw,
            recordsTotal: totalRecords,
            recordsFiltered: totalRecords,
            data: formattedData,
          });
          $('#check-all').prop('checked', false);
        } else {
          console.log('❌ API 返回失敗');
          dtCallback({
            draw: 1,
            recordsTotal: 0,
            recordsFiltered: 0,
            data: [],
          });
        }
      })
      .catch((err) => {
        console.log('❌ API 錯誤:', err);
        showMessage('error', err?.message || '載入失敗');
        console.error('fetchMachineList error', err);
        dtCallback({
          draw: 1,
          recordsTotal: 0,
          recordsFiltered: 0,
          data: [],
        });
      });
  };

  const columnConfig = [
    {
      orderable: false,
      order: null,
      title:
        '<div class="form-check"><input class="form-check-input" type="checkbox" value="" id="check-all" data-show-indeterminate="true"/><label class="form-check-label" for="check-all"></label></div>',
      data: null,
      render: function (data, type, row, meta) {
        const checkboxId = 'cks-rolePerm-' + meta.row;
        return `
                <div class="form-check">
                    <input class="form-check-input item-cks-customer" type="checkbox" value="" id="${checkboxId}" name="cks" />
                    <label class="form-check-label" for="${checkboxId}"></label>
                </div>
            `;
      },
      width: '5%',
    },
    {
      title: '<div class="text-start">年份</div>',
      className: '',
      data: 'recordYear',
      orderName: 'record_year',
      render: (data) => {
        return `
            <div class="text-start">
             ${data}
            </div>
            `;
      },
    },
    {
      title: '交機編號',
      className: 'dt-center',
      data: 'deliveryCode',
      orderName: 'delivery_code',
      defaultContent: '',
    },
    {
      title: '機械型式',
      className: 'dt-center',
      data: 'machineModel',
      orderName: 'machine_model',
      defaultContent: '',
    },
    {
      title: '機械番號',
      className: 'dt-center',
      data: 'machineSerialNumber',
      orderName: 'machine_serial_number',
      defaultContent: '',
    },
    {
      title: 'IM代表號碼',
      className: 'dt-center',
      data: 'imCode',
      orderName: 'im_code',
      defaultContent: '',
    },
    {
      title: '機種',
      className: 'dt-center',
      data: 'machineTypeName',
      orderName: 'machine_type_id',
      defaultContent: '',
    },
    {
      title: '狀態',
      className: 'dt-center',
      orderable: false,
      data: 'statusData',
      defaultContent: '',
      render: ({id, flgStatus}) => {
        const elID = ['machine', 'list', 'switch', generateRandomID(15)].join(
          '-',
        );
        const switchDiv = document.createElement('div');
        switchDiv.className = 'form-check form-switch';

        const inputEl = document.createElement('input');
        inputEl.className =
          'form-check-input enable-switch machine-status-switch';
        inputEl.type = 'checkbox';
        inputEl.role = 'switch';
        inputEl.checked = flgStatus === flgStatusEnum.active;
        inputEl.disabled = baseComponent.checkPermission(
          enumList.moduleEnums.machine,
          enumList.accessModeEnums.update,
        )
          ? ''
          : 'disabled';
        Object.assign(inputEl.dataset, {id});
        const labelEl = document.createElement('label');
        labelEl.className = 'form-check-label';
        labelEl.setAttribute('for', elID);

        switchDiv.appendChild(inputEl);
        switchDiv.appendChild(labelEl);
        return switchDiv;
      },
    },
    {
      title: '備註',
      className: 'dt-center',
      data: 'memo',
      orderName: 'memo',
      defaultContent: '',
    },
    {
      orderable: false,
      order: null,
      data: null,
      className: 'dt-right',
      render: (data, type, row, meta) => {
        const editId = 'edit-customer-' + meta.row;
        const machineBindingHistoryButtonId =
          'show-machine-binding-history-' + meta.row;
        const updateButton = baseComponent.checkPermission(
          enumList.moduleEnums.machine,
          enumList.accessModeEnums.update,
        )
          ? `<button type="button" class="btn btn-sm btn-link machine-edit-btn" id="${editId}">
                    <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                        <use href="#ico-edit"></use>
                    </svg>
                    修改
                </button>`
          : '';
        const machineBindingHistoryButton = baseComponent.checkPermission(
          enumList.moduleEnums.machine,
          enumList.accessModeEnums.read,
        )
          ? `<button type="button" class="btn btn-sm btn-link show-machine-binding-history-btn" id="${machineBindingHistoryButtonId}">
                綁定紀錄
              </button>`
          : '';
        return `
                <div class="btn-group" role="group" aria-label="">
                    ${updateButton}
                    ${machineBindingHistoryButton}
                </div>`;
      },
    },
  ];

  const prepareMachineTable = () => {
    const orderConfig = {
      idx: 1,
      dir: 'asc',
    };

    const fixedColumnsConfig = {
      start: 1,
    };

    // 清除舊的 DataTable
    if ($.fn.DataTable.isDataTable('#datatable__machineList')) {
      $('#datatable__machineList').DataTable().destroy();
    }

    // 創建新的 DataTable
    tableRef.current = DataTableComponent(
      '#datatable__machineList',
      [],
      columnConfig,
      orderConfig,
      fixedColumnsConfig,
      true, // bPaginate
      true, // bScrollX
      true, // bServerSide
      ajax, // serverSideCallback
    );

    batchCheckControls();
  };

  return {
    machineList,
    setSearchParams,
    checkedMachineIds,
    setCheckedMachineIds,
  };
};
